import { ChangeDetectorRef } from '@angular/core';
import { Observable, Subscription, Subject } from 'rxjs';
import { FilterField, FilterFieldConfig, FilterFieldType } from '../filter';
import { subscribeRadioFilterFieldToTranslator } from './filter-field-radio.translation';

export interface Radio {
  name: string;
  id: string;
}

export class RadioFilterField extends FilterField<Radio> {
  readonly type: FilterFieldType = 'radio';
  private readonly valueChanged$$ = new Subject<void>();
  readonly valueChanged$ = this.valueChanged$$.asObservable();

  options: Radio[];

  constructor(config: FilterFieldConfig) {
    super(config);
    this.value = config.value || config.options![0];
  }

  appliedFieldText(): string {
    return this.value!.name;
  }

  serializeValue(): string {
    return this.value!.id;
  }

  deserializeValue(urlParam: string): Radio | null {
    return this.options.find((radio) => radio.id === urlParam) || null;
  }

  public changeValue(value?: any): void {
    if (value === this.value) {
      return;
    }

    this.value = value;
    if (this.valueChanged) {
      this.valueChanged(this);
    }
    this.valueChanged$$.next();
  }

  /**
   * @see subscribeRadioFilterFieldToTranslator
   */
  subscribeToTranslator(
    translator: {
      stream: (key: string | Array<string>) => Observable<string | any>;
      instant: (key: string | Array<string>) => string | any;
    },
    cd: ChangeDetectorRef,
  ): Subscription[] {
    const superSubs = super.subscribeToTranslator(translator, cd);
    const radioSubs = subscribeRadioFilterFieldToTranslator(this, translator, cd);
    return superSubs.concat(radioSubs);
  }
}
